import { useMutation } from '@tanstack/react-query';
import {
  ActivityReportingRequirementsViewModel,
  UpdateActivityReportingRequirementsModel
} from '../../../../../features/activities/editActivity/editReportingRequirements/types';
import { getAxios } from '../../../../../lib/axios';
import { ActivityEndpoints } from '../../../../../constants/endpoints/activityEndpoints.ts';

export const useGetUpdatedNewReportingReqMutation = () => {
  return useMutation({
    mutationFn: async (vars: {
      companyId: number;
      travellerIds: number[];
      currentModel: UpdateActivityReportingRequirementsModel;
    }) => {
      return await getAxios().post<ActivityReportingRequirementsViewModel>(
        `${ActivityEndpoints.reportingRequirements.getNew(vars.companyId, vars.travellerIds)}`,
        vars.currentModel
      );
    }
  });
};
